console.log("Hello from app.js");

document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrambleTextPlugin);
  gsap.registerPlugin(ScrollTrigger);
  gsap.registerPlugin(SplitText);

  const checkShopify = setInterval(function () {
    // Vérifier si window.Shopify et window.Shopify.customerPrivacy sont définis
    if (window.Shopify && window.Shopify.customerPrivacy) {
      clearInterval(checkShopify); // Arrêter la vérification
      initWishlist();
    }
  }, 100);

  initFollowMouse();
  window.addEventListener("scroll", scrolling);
  updateCartUpsell();
  detectPopovers();
  // initHeader();

  if (window.innerWidth > 1024) {
    document.querySelectorAll("[scramble-text]").forEach((item) => {
      item.addEventListener("mouseenter", function (event) {
        const textToAnimate = item.dataset.text;
        const spanText = item.querySelector(".text-animate");
        gsap.to(spanText, {
          duration: 1,
          scrambleText: {
            chars: "lowerCase",
            text: textToAnimate,
          },
        });
      });
    });
  }
});

function initWishlist() {
  console.log("Initialisation de la liste de souhaits");
  const lienConsenti = document.getElementById("wishlist-menu-item");
  function showPrivacy(e) {
    e.preventDefault();
    privacyBanner.showPreferences();
  }
  function mettreAJourAffichage() {
    console.log("Mise à jour de l'affichage de la liste de souhaits");
    // Vérifie si l'API de consentement de Shopify est disponible
    if (window.Shopify && window.Shopify.customerPrivacy) {
      console.log("API de consentement de Shopify disponible");
      // La fonction userCanBeTracked() renvoie true si le visiteur a accepté
      // les cookies (au minimum analytics ou marketing).
      if (!window.Shopify.customerPrivacy.userCanBeTracked()) {
        console.log("User cannot be tracked");
        if (lienConsenti) {
          lienConsenti.addEventListener("click", showPrivacy);
        }
      } else {
        if (lienConsenti) {
          lienConsenti.removeEventListener("click", showPrivacy);
        }
      }
    }
  }

  mettreAJourAffichage();

  document.addEventListener("visitorConsentCollected", function (event) {
    // L'objet "event.detail" contient les préférences de consentement de l'utilisateur
    console.log("Consentement collecté ou mis à jour !", event.detail);

    // Vous pouvez vérifier des consentements spécifiques comme ceci :
    if (event.detail.marketingAllowed) {
      console.log("L'utilisateur a accepté le marketing.");
    }
    if (event.detail.analyticsAllowed) {
      console.log("L'utilisateur a accepté l'analytique.");
    }

    // Appelez votre fonction pour mettre à jour l'affichage
    mettreAJourAffichage();
  });
}

function initHeader() {
  let lastScrollTop = 0;
  const header = document.querySelector("header");

  if (header) {
    // Initial setup - hide the header off-screen
    gsap.set(header, { y: 0 });

    // Create a scroll listener
    ScrollTrigger.create({
      start: "top top",
      end: "max",
      onUpdate: (self) => {
        const scrollTop = self.scroll();

        // Determine scroll direction
        if (scrollTop > lastScrollTop) {
          // Scrolling down
          let offset = 8;
          if (document.querySelector(".announcement-bar")) {
            offset += document.querySelector(".announcement-bar").offsetHeight;
          }
          offset += header.offsetHeight;
          gsap.to(header, {
            y: -offset,
            duration: 0.3,
            ease: "power2.out",
          });
        } else {
          // Scrolling up
          gsap.to(header, {
            y: 0,
            duration: 0.3,
            ease: "power2.out",
          });
        }

        // Update last scroll position
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      },
    });
  }
}

function fixMobileSubmenus() {
  return;
  const mobileSubmenus = document.querySelectorAll(
    ".mobile-submenu:not(.initialized)",
  );
  mobileSubmenus.forEach((submenu) => {
    submenu.classList.add("initialized");
    const submenuHeight = submenu.scrollHeight;
    const submenuTopPosition = submenu.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;
    if (submenuHeight + submenuTopPosition > windowHeight) {
      submenu
        .querySelector(".mobile-submenu-scroll")
        .classList.remove("hidden");
      submenu.querySelector(".mobile-submenu-scroll").classList.add("flex");
      submenu.addEventListener("scroll", function () {
        const scrollTop = submenu.scrollTop;
        if (
          scrollTop + windowHeight <
          submenuHeight + submenuTopPosition - 20
        ) {
          gsap.to(submenu.querySelector(".mobile-submenu-scroll"), {
            duration: 0.3,
            ease: "power2.out",
            opacity: 1,
          });
        } else {
          gsap.to(submenu.querySelector(".mobile-submenu-scroll"), {
            duration: 0.3,
            ease: "power2.out",
            opacity: 0,
          });
        }
      });
    }
  });
}

function detectPopovers() {
  const urlParams = new URLSearchParams(window.location.search);
  const popoverParam = urlParams.get("popover");

  if (popoverParam) {
    if (popoverParam === "product-out-of-stock-panel") {
      const bisCta = document.querySelector(".klaviyo-bis-trigger");
      if (bisCta) {
        // If the popover is for the out-of-stock panel, trigger the Klaviyo button
        setTimeout(() => {
          bisCta.click();
        }, 400);
      }
    } else {
      // Find popover with the matching name/id
      const targetPopover = document.querySelector(
        `[popover][id="${popoverParam}"]`,
      );
      if (targetPopover) {
        // Delay slightly to ensure DOM is fully loaded
        setTimeout(() => {
          targetPopover.showPopover();
        }, 400);
      }
    }
  }
}

function scrolling() {
  // document.documentElement.classList?.remove("nav-open");
  // let scrollTop = window.scrollY || document.documentElement.scrollTop;
  // window.scrollY > 100 && scrollTop > lastScrollTop
  //   ? document.documentElement.classList.add("scroll-down")
  //   : document.documentElement.classList.remove("scroll-down");
  // lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

  // if (window.scrollY > 10) document.documentElement.classList.add("not-top");
  // else document.documentElement.classList.remove("not-top");
  let offset = 10;
  if (document.querySelector(".announcement-bar")) {
    offset += document.querySelector(".announcement-bar").offsetHeight;
  }
  if (window.scrollY > offset)
    document.documentElement.classList.add("not-top");
  else document.documentElement.classList.remove("not-top");
}

function initFollowMouse() {
  if (!window.matchMedia("(min-width: 768px)").matches) {
    return;
  }
  const elements = document.querySelectorAll(".follow-mouse");
  const speed = 0.15;

  elements.forEach((element) => {
    const parent = element.parentElement;
    const parentWidth = parent.offsetWidth;
    const parentHeight = parent.offsetHeight;

    const pos = { y: parentHeight / 2, x: parentWidth / 2 };
    const mouse = { y: parentHeight / 2, x: parentWidth / 2 };

    element.classList.remove("-translate-x-1/2");
    element.classList.remove("-translate-y-1/2");
    element.style.transform = `translate(${pos.x}px, ${pos.y}px) translate(-50%, -50%)`;
    element.style.position = "absolute";
    element.style.top = "0";
    element.style.left = "0";

    parent.addEventListener("mousemove", function (event) {
      const rect = parent.getBoundingClientRect();
      mouse.x = event.clientX - rect.left;
      mouse.y = event.clientY - rect.top;
    });
    function animate() {
      let destY = mouse.y;
      let destX = mouse.x;
      // Constrain the destination within parent boundaries
      // Calculate boundaries to keep element inside parent
      const offsetX = element.offsetWidth / 2;
      const offsetY = element.offsetHeight / 2;
      const minX = offsetX;
      const minY = offsetY;
      const maxX = parentWidth - offsetX;
      const maxY = parentHeight - offsetY;

      // Apply constraints
      destX = Math.max(minX, Math.min(destX, maxX));
      destY = Math.max(minY, Math.min(destY, maxY));
      pos.y += (destY - pos.y) * speed;
      pos.x += (destX - pos.x) * speed;

      element.style.transform = `translate(${pos.x}px, ${pos.y}px) translate(-50%, -50%)`;

      requestAnimationFrame(animate);
    }

    parent.addEventListener("mouseenter", function (event) {
      element.classList.remove("opacity-0");
    });

    parent.addEventListener("mouseleave", function (event) {
      element.classList.add("opacity-0");
    });
    animate();
  });
}

function addToCart(e) {
  e.preventDefault();
  // Check if there's a hidden zakeke input with value 1
  const zakekeInput = e.target.querySelector('input[name="zakeke-product-id"]');
  if (zakekeInput) {
    // Product is a zakeke customized product
    // Get product ID and form ID for zakeke customization
    const productId = zakekeInput.value;
    const formId = e.target.querySelector('input[name="id"]').value;

    // Build the URL with query parameters
    const zakekeUrl = `/apps/zakeke?pid=${productId}&id=${formId}`;

    // Redirect to the customization app
    window.location.href = zakekeUrl;
    return;
  }
  e.target.querySelector('[type="submit"]').disabled = true;

  let formData = Object.fromEntries(new FormData(e.target));
  // console.log(formData)
  let properties = {};
  for (const key in formData) {
    if (key.startsWith("properties[")) {
      let propName = key.match(/properties\[(.*?)\]/)[1];
      properties[propName] = formData[key];
      delete formData[key];
    }
  }
  if (Object.keys(properties).length > 0) formData.properties = properties;
  formData.sections = "cart";

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=UTF-8",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      if (erreurs) {
        console.log(":::::");
        console.log(erreurs);
        console.log(":::::");
        // addToCartErrors(erreurs);
        e.target.querySelector('[type="submit"]').disabled = false;
        return false;
      } else {
        // hideAddToCartErrors();
      }
      if (data.sections.cart) {
        // Get the cart drawer content from the response and update the DOM
        const parser = new DOMParser();
        const cartDoc = parser.parseFromString(data.sections.cart, "text/html");
        const cartDrawerContent = cartDoc.querySelector("#cart-drawer");
        const cartCount = cartDoc.querySelector("#cart-item-count");
        if (cartCount) {
          document.querySelector("#cart-item-count").innerHTML =
            cartCount.innerHTML;
          document
            .querySelector("#cart-item-count")
            .classList.remove("max-md:!hidden");
        }
        if (cartDrawerContent) {
          document.querySelector("#cart-drawer").innerHTML =
            cartDrawerContent.innerHTML;
          updateCartUpsell();
        }
      }
      document
        .querySelectorAll(".product-gift-card-panel[popover]")
        .forEach((el) => {
          el.hidePopover();
        });
      document.getElementById("cart-drawer").showPopover();
      document
        .querySelectorAll(".product-variant-panel[popover]")
        .forEach((el) => {
          el.hidePopover();
        });
      e.target.querySelector('[type="submit"]').disabled = false;
    })
    .catch((error) => {
      console.error("Erreur :", error);
    });
}

function updateCartItemQty(btn, change, is_gift_card = false) {
  const itemId = btn.dataset.itemId;
  let shouldUpdate = change == 0;
  let newQty = 0;
  if (change != 0) {
    const currentQty = is_gift_card
      ? 1
      : parseInt(
          btn.parentElement.querySelector(".quantity-display").textContent,
        );
    newQty = Math.max(0, change == 0 ? 0 : currentQty + change);
    shouldUpdate = newQty != currentQty;
  }

  if (shouldUpdate) {
    // Update the cart using the Shopify AJAX API
    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: itemId,
        quantity: newQty,
        sections: "cart", // Specify the section to update
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        if (cart.sections.cart) {
          const parser = new DOMParser();
          const cartDoc = parser.parseFromString(
            cart.sections.cart,
            "text/html",
          );
          const cartDrawerContent = cartDoc.querySelector("#cart-drawer");
          if (cartDrawerContent) {
            document.querySelector("#cart-drawer").innerHTML =
              cartDrawerContent.innerHTML;
            updateCartUpsell();
          }
          const cartCount = cartDoc.querySelector("#cart-item-count");
          if (cartCount) {
            document.querySelector("#cart-item-count").innerHTML =
              cartCount.innerHTML;
            if (cartCount.innerHTML == "0") {
              document
                .querySelector("#cart-item-count")
                .classList.add("max-md:!hidden");
            } else {
              document
                .querySelector("#cart-item-count")
                .classList.remove("max-md:!hidden");
            }
          }
        }
      })
      .catch((error) => console.error("Error updating cart:", error));
  }
}

function updateCartUpsell() {
  if (window.matchMedia("(min-width: 1024px)").matches) {
    document
      .querySelectorAll("#cart-drawer [scramble-text]")
      .forEach((item) => {
        item.addEventListener("mouseenter", function (event) {
          const textToAnimate = item.dataset.text;
          const spanText = item.querySelector(".text-animate");
          gsap.to(spanText, {
            duration: 1,
            scrambleText: {
              chars: "lowerCase",
              text: textToAnimate,
            },
          });
        });
      });
  }

  if (!document.querySelector("#cart-drawer .product-related")) {
    return;
  }

  if (window.matchMedia("(min-width: 768px)").matches) {
    // DESKTOP
    const handleIntersectionRelated = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);
      const splide = new Splide("#cart-drawer .splide-desktop", {
        trimSpace: false,
        pauseOnHover: false,
        pagination: false,
        flickMaxPages: 1,
        flickPower: 30,
        type: "fade",
        perPage: 1,
        perMove: 1,
      }).mount();
      const arrows = document.querySelector(
        "#cart-drawer .splide-desktop .splide__arrows",
      );
      const cardContainer = document.querySelector(
        "#cart-drawer .splide-desktop",
      );
      const card = document.querySelector(
        "#cart-drawer .splide-desktop .cart-upsell-card",
      );
      // Get positions of cards relative to their container
      if (cardContainer && card && arrows) {
        const containerRect = card.closest(".splide").getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();

        // Calculate relative position
        const topPosition = cardRect.top - containerRect.top;
        const rightPosition = containerRect.right - cardRect.right;
        arrows.style.top = `${topPosition + 16}px`;
        arrows.style.right = `${rightPosition + 16}px`;
      }

      initSelectCartUpsell();
    };

    const productRecommendationsSection = document.querySelector(
      "#cart-drawer .splide-desktop.product-related",
    );
    const observer = new IntersectionObserver(handleIntersectionRelated, {
      rootMargin: "0px 0px 200px 0px",
    });

    observer.observe(productRecommendationsSection);
  } else {
    // MOBILE
    if (!document.querySelector("#cart-drawer .product-related")) {
      const splide = new Splide("#cart-drawer .splide-mobile", {
        trimSpace: false,
        pauseOnHover: false,
        flickMaxPages: 1,
        flickPower: 30,
        pagination: false,
        type: "loop",
        gap: 10,
        perPage: 2,
        perMove: 1,
      }).mount();
      initSelectCartUpsell();
    }
  }
}

function initSelectCartUpsell() {
  const forms = document.querySelectorAll(".cart-upsell-form");
  forms.forEach((form) => {
    const priceElement = form.querySelector(".product-variant-price");
    if (!priceElement) {
      return;
    }
    const optionInputs = form.querySelectorAll("select option");
    const selectInput = form.querySelector("select");
    let variants = form.getAttribute("data-variant")
      ? JSON.parse(form.getAttribute("data-variant"))
      : [];
    let currentVariant = null;

    // Function to update the displayed price
    function updatePrice() {
      if (currentVariant && currentVariant.available) {
        const priceInCents = currentVariant.price;
        const moneyFormat = form.getAttribute("data-money-format");
        const formattedPrice = Shopify.formatMoney(priceInCents, moneyFormat);
        priceElement.innerHTML = formattedPrice;
      } else {
        priceElement.innerHTML = "";
      }
    }

    // Function to find the matching variant based on selected options
    function findVariant(selectedOptions) {
      return variants.find((variant) => {
        return variant.options.every(
          (option, index) => option === selectedOptions[index],
        );
      });
    }

    // Get the initial selected options and update price
    function getSelectedOptions() {
      const selectedOptions = [];

      // Group inputs by option position
      const optionsByPosition = {};
      optionInputs.forEach((input) => {
        if (selectInput.value === input.value) {
          const position = parseInt(input.dataset.optionPosition);
          optionsByPosition[position] = input.value;
        }
      });

      // Sort by position and collect values
      Object.keys(optionsByPosition)
        .sort((a, b) => a - b)
        .forEach((position) => {
          selectedOptions.push(optionsByPosition[position]);
        });
      return selectedOptions;
    }

    function updateId(currentVariant) {
      const variantId = currentVariant ? currentVariant.id : null;
      const idInput = form.querySelector('input[name="id"]');
      idInput.value = variantId || "";
    }

    // Initialize and set up event listeners
    const selectedOptions = getSelectedOptions();
    currentVariant = findVariant(selectedOptions);
    updatePrice();
    updateId(currentVariant);

    optionInputs.forEach((input) => {
      input.addEventListener("change", () => {
        const selectedOptions = getSelectedOptions();
        currentVariant = findVariant(selectedOptions);
        updatePrice();
        updateId(currentVariant);
      });
    });
  });
}

function updateQuantity(elem, qty) {
  const input = elem.closest(".quantity").querySelector("input");
  const currentQty = parseInt(input.value) || 0;
  let newQty = currentQty + qty;
  if (newQty < 1) {
    newQty = 1;
  }
  input.value = newQty;
}